import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http' ;
import { firstValueFrom } from 'rxjs';
import { HhsgSharedAppSettings } from '../models/app-settings.model';

@Injectable({
  providedIn: 'root'
})
export class HhsgSharedConfigService {
  appSettings: HhsgSharedAppSettings;

  constructor(private _http: HttpClient) {
    this.appSettings = new HhsgSharedAppSettings();
  }

  load(appSettingsFile: string): Promise<void> {
    return firstValueFrom(this._http.get<HhsgSharedAppSettings>(appSettingsFile))
        .then(result => {
            this.appSettings = result;
        });
  }
}
